import { Plan } from "../models/SubscriptionModels";
import "./PlanSelect.css";

interface PlanSelectProps {
  plans: Plan[];
  value: string;
  disabled?: boolean;
  loading?: boolean;
  onChange: (planId: string) => void;
}

const PlanSelect = ({
  plans,
  value,
  disabled = false,
  loading = false,
  onChange,
}: PlanSelectProps) => (
  <select
    id="sub-plan"
    className="plan-select"
    value={value}
    disabled={disabled || loading}
    onChange={(e) => onChange(e.target.value)}
  >
    {loading ? (
      <option value="">Loading plans…</option>
    ) : plans.length === 0 ? (
      <option value="">No public plans available</option>
    ) : (
      <>
        <option value="">Select a plan…</option>
        {plans.map((plan) => (
          <option key={plan.id} value={plan.id}>
            {plan.name} — {plan.currency} {plan.priceMonthly} / {plan.billingPeriodDays} days
          </option>
        ))}
      </>
    )}
  </select>
);

export default PlanSelect;